import { Heading, Box, Text, Grid } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BlurredStain } from '@/components/ui/shared/backgrounds/BlurredStain/BlurredStain';
import { OriginalsPromoVideo } from '@/components/ui/shared/promo-videos/OriginalsPromoVideo/OriginalsPromoVideo';

export const LibrariansOriginals: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid
      pt={24}
      position="relative"
      pb={32}
      templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
      gap={{ base: 0, lg: 20, xl: 72 }}
    >
      <BlurredStain right="-200px" top="-50px" />
      <Box mb={{ base: 16, lg: 0 }} alignSelf="center">
        <Heading fontSize={{ base: '32px', lg: '48px' }} lineHeight={{ base: 10, lg: '60px' }} mb={6}>
          {t('librarians.originals.title')}
        </Heading>
        <Text fontSize="xl" lineHeight={7} fontFamily="body">
          {t('librarians.originals.description')}
        </Text>
      </Box>
      <OriginalsPromoVideo m={{ base: '0 auto', lg: '0 0 0 auto' }} />
    </Grid>
  );
};
